import { IWorkHours } from '../models';

export function checkRanges(schedule: IWorkHours, scheduleForCheck: IWorkHours): boolean {
  return schedule.from >= scheduleForCheck.from && schedule.to <= scheduleForCheck.to;
}
